<div class="button-panel no-print">
    <a mat-button [routerLink]="[getLocation()]" [queryParams]="getQueryParams()" color="primary">
        <mat-icon>chevron_left</mat-icon>        
        {{ linkText }}
    </a>
</div>